export const stringOperators = {
  '=': 'equals',
  '<>': 'does not equal',
  ILIKE: 'contains',
  'NOT ILIKE': 'does not contain'
} as const;
export const uint32Operators = {
  '=': 'equals',
  '<>': 'does not equal',
  '>': 'is greater than',
  '<': 'is less than'
} as const;
export const IN_REGEXP = new RegExp('_in(_|$)', 'gi');
export const OUT_REGEXP = new RegExp('_out(_|$)', 'gi');
export const TO_REGEXP = new RegExp('_to(_|$)', 'gi');
export const FROM_REGEXP = new RegExp('_from(_|$)', 'gi');
export const SRC_REGEXP = new RegExp('_src(_|$)', 'gi');
export const DST_REGEXP = new RegExp('_dst(_|$)', 'gi');
